<template>
  <div class="panel">
    <div class="content">
      <div class="title-container">
        <div v-if="!editName" class="editable title" @click="editName = true">
          {{ sectionName }}<Pen class="edit-icon" />
        </div>
        <div v-else class="title-edit">
          <FireInput
            ref="sectionName-field"
            class="text-input"
            :value="sectionName"
            @change="value => (sectionName = value)"
          />
          <div class="cancel" @click.stop="undoSectionName">
            <Cross class="icon" />
          </div>
          <div class="validate" @click.stop="changeSectionName">
            <Check class="icon" />
          </div>
        </div>
        <InfoBubbleIcon class="icon info-bubble-anchor" @click="togglePopup" />
        <HelpBubble :content="sectionsInfos" :visible="showPopup" @on-click="closePopup" />
      </div>

      <div class="divider" />
      <div class="check">
        <input id="hideItem" v-model="hideItem" type="checkbox" />
        <label for="hideItem">{{ $t('editor.convictions.hide') }}</label>
      </div>
      <div class="divider" />
      <div class="section">
        <div v-for="item in items" :key="item.id" class="items">
          <div class="item">
            <div class="text relative-container">
              {{ $t('editor.convictions.values') }}

              <MagicWand
                class="magic-wand-container"
                :initial-text="item.content.convictions"
                :prompt-context="getMagicWandContext()"
                @insert="
                  value => {
                    itemChanged(value, 'convictions');
                    updateFields();
                  }
                "
              />
            </div>

            <FireArea
              :ref="`${item.id}-convictions-field`"
              :auto-focus="true"
              :template-div-container="'convictions'"
              :value="item.content.convictions"
              @change="value => itemChanged(value, 'convictions')"
            />
          </div>
        </div>
      </div>
    </div>
    <div ref="resize-handle" class="resize">
      <div class="line" />
      <div class="line" />
      <div class="line" />
    </div>
  </div>
</template>

<script>
import PanelMixin from './mixins/PanelMixin';
import InfoBubbleMixin from '@/components/panels/mixins/InfoBubbleMixin.vue';
import FireArea from '@/components/inputs/FireArea';
import FireInput from '@/components/inputs/FireInput';
import InfoBubbleIcon from '@/assets/icons/infobulle.svg';
import HelpBubble from '@/components/HelpBubble.vue';
import MagicWand from '@/components/magic-wand/MagicWand.vue';

import sectionInfosData from '@/helpers/SectionHelp.js';

export default {
  name: 'ConvictionPanel',
  components: {
    HelpBubble,
    FireArea,
    FireInput,
    InfoBubbleIcon,
    MagicWand,
  },
  mixins: [PanelMixin, InfoBubbleMixin],
  data() {
    return {
      hideItem: false,
      sectionId: 'conviction',
    };
  },
  computed: {
    sectionsInfos() {
      return sectionInfosData[this.sectionId];
    },
  },
  watch: {
    hideItem(value) {
      this.itemChanged(value, 'hidden');
    },
  },
  mounted() {
    this.scrollTo();

    this.checkIfMustOpenPopup(this.sectionId);
  },
  async created() {
    if (this.items.length === 0) {
      await this.$store.dispatch('items.create', {
        resumeId: this.$route.params.id,
        item: { content: { hidden: false }, order: 0, type: 'conviction' },
      });
    } else if (this.items.length > 1) {
      const idToRemove = this.items.map(i => i.id);
      idToRemove.shift();
      idToRemove.forEach(id => this.$store.dispatch('items.delete', id));
    }
    this.hideItem = !!this.items.find(i => i.type === 'conviction')?.content.hidden;
  },
  methods: {
    updateFields() {
      this.items.forEach(item => {
        if (this.$refs[`${item.id}-convictions-field`] && this.$refs[`${item.id}-convictions-field`][0]) {
          this.dontSendNext = true;
          this.$refs[`${item.id}-convictions-field`][0].input = item.content.convictions;
        }
      });
    },

    getMagicWandContext() {
      return JSON.stringify({
        candidate: this.resume.candidate,
        items: this.resume.items.filter(item => item.type !== 'conviction'),
      });
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/inspector.scss';

.check {
  display: flex;
  align-items: center;
  label {
    margin-left: 4px;
    user-select: none;
    display: block;
    @extend .uppercase-first;
    color: colors.$dark-grey-color;
    cursor: pointer;
  }
}

.relative-container {
  position: relative;
}

.magic-wand-container {
  position: absolute;
  top: 0;
  right: 0;
}

.title-container {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .icon {
    cursor: pointer;
    height: 24px;
    margin-right: 8px;
    transition-duration: 0.1s;

    &:hover {
      scale: 1.1;
    }

    &:active {
      scale: 0.9;
    }
  }
}
</style>
